export const thunkTypes = {
  GET_DETAIL: `supervisorDelivery/getDetail`,
  LIST_AMBASSADORS: `supervisorDelivery/listAmbassadors`,
  LIST_REPORTS: `supervisorDelivery/listReports`,
  LIST_ADDRESSES: `supervisorDelivery/listAddresses`,
  REASSIGN: `supervisorDelivery/reassign`,
  RESCHEDULE: `supervisorDelivery/reschedule`,
};
